import { createContext } from 'react'

import { FileUploadState, ProcessingStage, UploadItem } from './types'

interface UploadContextValue {
  items: UploadItem[]
  importProgress: {
    percent: number
    completed: number
    total: number
  }
  isUploading: boolean
  isComplete: boolean
  hasErrors: boolean
  startUploads: (files: File[]) => void
  jobId: string | null
  activeImportCount: number
  furthestStage: ProcessingStage | null
  isPanelVisible: boolean
  showUploadButton: boolean
  fileUploads: FileUploadState
}

export const UploadContext = createContext<UploadContextValue | null>(null)
